import { useDeferredValue, useMemo, useState } from 'react';
import type { ManagerProspectFilters } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/hooks/use-manager-prospect-filters';
import type { ManagerProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

interface FilteredManagerProspects {
  appliedSearchText: string;
  filteredProspects: ManagerProspectRowData[];
  searchText: string;
  setSearchText: (text: string) => void;
}

export const useFilteredManagerProspects = (
  prospects: ManagerProspectRowData[],
  filters: Pick<ManagerProspectFilters, 'repFilter' | 'stageFilter'>,
): FilteredManagerProspects => {
  const { repFilter, stageFilter } = filters;
  const [searchText, setSearchText] = useState('');
  const appliedSearchText = useDeferredValue(searchText).trim();

  const filteredProspects = useMemo(() => {
    const query = appliedSearchText.toLowerCase();

    return prospects.filter(
      (prospect) =>
        (repFilter.length === 0 ||
          (prospect.repUUID !== undefined &&
            repFilter.includes(prospect.repUUID))) &&
        (stageFilter.length === 0 || stageFilter.includes(prospect.stage)) &&
        (query.length === 0 || prospect.name.toLowerCase().includes(query)),
    );
  }, [appliedSearchText, prospects, repFilter, stageFilter]);

  return { appliedSearchText, filteredProspects, searchText, setSearchText };
};
